/**
 * Created by yarik on 18.7.17.
 */
import lazyLoading from "./lazyLoading";

export default {
  name: "networking",
  meta: {
    expanded: false,
    title: "menu.networking",
    iconClass: "vuestic-icon vuestic-icon-graph",
  },
  children: [
    {
      name: "Firewall",
      path: "/firewalls",
      component: lazyLoading("firewalls/Firewalls"),
      meta: {
        default: false,
        title: "menu.firewalls",
        newWindow: false,
      },
    },
    {
      name: "Anti DDoS Attacks",
      path: "/attacks",
      component: lazyLoading("attacks/Attacks"),
      meta: {
        default: false,
        title: "menu.ddos_attacks",
        newWindow: false,
      },
    },
    {
      name: "DNS",
      path: "/dns",
      component: lazyLoading("dns/Domains"),
      meta: {
        default: false,
        title: "menu.dns",
        newWindow: false,
      },
    },
    {
      name: "VPC",
      path: "/network/vpc",
      meta: {
        default: false,
        title: "menu.vpc",
        newWindow: false,
        newFrontend: true
      },
    },
    {
      name: "Floating IP",
      path: "/network/floating-ip",
      meta: {
        default: false,
        title: "menu.floatingIp",
        newWindow: false,
        newFrontend: true
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/networking.js